import { FONT_BRIGHTNESS_MAPPING } from './constants';
export const fonts = ({ themeVariables, }) => {
    const { fontBrightness } = themeVariables;
    const asphalt = FONT_BRIGHTNESS_MAPPING.asphalt[fontBrightness];
    const black = FONT_BRIGHTNESS_MAPPING.black[fontBrightness];
    const dove = FONT_BRIGHTNESS_MAPPING.dove[fontBrightness];
    return {
        'body-asphalt-italic': {
            color: asphalt,
            fontSize: 2,
            fontStyle: 'italic',
            fontWeight: 0,
            lineHeight: 2,
        },
        'body-dove-italic': {
            color: dove,
            fontSize: 2,
            fontStyle: 'italic',
            fontWeight: 0,
            lineHeight: 2,
        },
        'body-regular-asphalt': {
            color: asphalt,
            fontSize: 2,
            fontWeight: 0,
            lineHeight: 2,
        },
        'body-regular-black': {
            color: black,
            fontSize: 2,
            fontWeight: 0,
            lineHeight: 2,
        },
        'body-regular-dove': {
            color: dove,
            fontSize: 2,
            fontWeight: 0,
            lineHeight: 2,
        },
        'body-semibold-asphalt': {
            color: asphalt,
            fontSize: 2,
            fontWeight: 1,
            lineHeight: 2,
        },
        'body-semibold-black': {
            color: black,
            fontSize: 2,
            fontWeight: 1,
            lineHeight: 2,
        },
        'body-semibold-dove': {
            color: dove,
            fontSize: 2,
            fontWeight: 1,
            lineHeight: 2,
        },
        'footnote-asphalt': {
            color: asphalt,
            fontSize: 0,
            fontWeight: 0,
            lineHeight: 0,
        },
        'footnote-asphalt-italic': {
            color: asphalt,
            fontSize: 0,
            fontStyle: 'italic',
            fontWeight: 0,
            lineHeight: 0,
        },
        'footnote-dove': {
            color: dove,
            fontSize: 0,
            fontWeight: 0,
            lineHeight: 0,
        },
        'footnote-dove-italic': {
            color: dove,
            fontSize: 0,
            fontStyle: 'italic',
            fontWeight: 0,
            lineHeight: 0,
        },
        'h1-regular': {
            color: black,
            fontSize: [8, 9],
            fontWeight: 0,
            lineHeight: [8, 9],
        },
        'h1-semibold': {
            color: black,
            fontSize: [8, 9],
            fontWeight: 1,
            lineHeight: [8, 9],
        },
        'h2-regular': {
            color: black,
            fontSize: [6, 7],
            fontWeight: 0,
            lineHeight: [6, 7],
        },
        'h2-semibold': {
            color: black,
            fontSize: [6, 7],
            fontWeight: 1,
            lineHeight: [6, 7],
        },
        'h3-regular': {
            color: black,
            fontSize: [4, 5],
            fontWeight: 0,
            lineHeight: [4, 5],
        },
        'h3-semibold': {
            color: black,
            fontSize: [4, 5],
            fontWeight: 1,
            lineHeight: [4, 5],
        },
        'h4-regular': {
            color: black,
            fontSize: 3,
            fontWeight: 0,
            lineHeight: 3,
        },
        'h4-semibold': {
            color: black,
            fontSize: 3,
            fontWeight: 1,
            lineHeight: 3,
        },
        'metadata-regular-asphalt': {
            color: asphalt,
            fontSize: 1,
            fontWeight: 0,
            lineHeight: 1,
        },
        'metadata-regular-dove': {
            color: dove,
            fontSize: 1,
            fontWeight: 0,
            lineHeight: 1,
        },
        'metadata-semibold-asphalt': {
            color: asphalt,
            fontSize: 1,
            fontWeight: 1,
            lineHeight: 1,
        },
        'metadata-semibold-dove': {
            color: dove,
            fontSize: 1,
            fontWeight: 1,
            lineHeight: 1,
        },
    };
};
//# sourceMappingURL=fonts.js.map